import { createSlice } from '@reduxjs/toolkit';

const initialConfigState = {
  tab: 0,
  sideNavIndex: 0,
};

const configSlice = createSlice({
  name: 'configSetting',
  initialState: initialConfigState,
  reducers: {
    resetConfigSetting: () => initialConfigState,
    updateTabPanel(state, { payload }) {
      state.tab = payload;
    },
    updateSideNavIndex(state, { payload }) {
      state.sideNavIndex = payload;
    },
  },
});

export const { updateTabPanel, resetConfigSetting, updateSideNavIndex } = configSlice.actions;
export default configSlice.reducer;
